import {FC} from "react";
import {useSelector} from "react-redux";
import {Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {getPatientAsymmetry} from "../../../../../../redux/selectors/patientsSelector";
import {IAsymmetry} from "../../../../../../utils/interfaces";
import {format, parse} from "date-fns";
import {NoDataPage} from "../../../../../common/NoDataPage/NoDataPage";

const formatAsymmetry = (steps: IAsymmetry[]) => {
  return steps.map(step => ({
    ...step,
    date: format(parse(step.date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy'),
  }))
}

export const AsymmetryGraph: FC = () => {
  const asymmetryData = useSelector(getPatientAsymmetry)
  const formattedAsymmetryData = Array.isArray(asymmetryData) ? formatAsymmetry(asymmetryData) : [];

  if (!formattedAsymmetryData.length) {
    return <NoDataPage
      message="There is no asymmetry data for this period"
      description=""
    />
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        style={{width: '100%', maxHeight: '430px'}}
        data={formattedAsymmetryData}
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis tickFormatter={(value) => `${value}%`} />
        <Tooltip formatter={(value) => `${value}%`} />
        <Area type="monotone" dataKey="asymmetry" stroke="#7897FF" fill="#7897FF" />
      </AreaChart>
    </ResponsiveContainer>
  );
}
